import React, { useEffect, useState } from 'react'

import DesktopTabs from './Desktop/DesktopTabs'
import { type TabItemProps } from './Desktop/Tab'

export type TabsProps = {
  /** Array of Tabs to display */
  tabs: Array<TabItemProps>
  /** Style the component with the subtabs design */
  subtabs?: boolean
  /** Determine the active tab */
  active?: number
  /** Optional identifier */
  customId?: string
  /** Optionally add a className to Tabs */
  customClass?: string
  /** Optionally force all tabs to be an equal width across the width of its container */
  equalWidth?: boolean
  /** Function to help set the active tab */
  callout?: (tabId: number) => void
  /** Optional prop to add a test id to the Tabs for QA testing */
  qaTestId?: string
}

const Tabs = (props: TabsProps): React.JSX.Element => {
  const { active, tabs, callout, qaTestId = 'tabs' } = props,
    [activeTabId, setActiveTabId] = useState<number>(
      active !== undefined ? active : tabs[0].id,
    )

  const tabCallout = (tabId: number) => {
    setActiveTabId(tabId)
    callout?.(tabId)
  }

  useEffect(() => {
    if (active !== undefined) {
      setActiveTabId(active)
    }
  }, [active])

  return (
    <DesktopTabs
      {...props}
      callout={tabCallout}
      activeTabId={activeTabId}
      qaTestId={qaTestId}
    />
  )
}

export default Tabs
